import Vue from 'vue';
import Vuex from 'vuex';
import main from './module/MainModule/index.js';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    main,
  },
});
